import CalendarService from './CalendarService'

class PricingModel

  @payoutForEventSpace: (event, price) ->
    return (0).toFixed(2) unless price?
    (price - @recessFeeForEventSpace(event, price)).toFixed(2)

  @recessFeeForEventSpace: (event, price) ->
    return (0).toFixed(2) unless price?
    takeRate = 30 # use event.ctx.pricing_table[pricing_model], add pricing_model to signature arguments
    (price * (takeRate / 100)).toFixed(2)

  @audienceListingSpacesForCampaign: (audienceListing, campaign) ->
    pricing_table = audienceListing.pricing_table || {}

    spaces = for creative, descriptorList of campaign.creatives
      descriptor = descriptorList[0] or { line_item_pricing_model: 'custom', type: 'custom' }
      { line_item_pricing_model, type } = descriptor

      space = Object.values(audienceListing.spaces).find((s) -> s.type is type)
      continue unless space?
      pricing_model_descriptor = pricing_table[line_item_pricing_model] or { style: 'custom', price_in_cents: -1 }

      { style, price_in_cents } = pricing_model_descriptor
      price_in_cents = space.supplier_price_in_cents if 'marketplace' is style or not 0 is parseInt(price_in_cents)
      price_in_cents ||= space.supplier_price_in_cents

      quantity = space.min_quantity or 1
      quantity = audienceListing.reach if 'video_wall' is line_item_pricing_model

      maxQuantity = space.max_quantity

      space.cart_unit_price_in_dollars = price_in_cents / 100
      space.cart_total_price_in_dollars = space.cart_unit_price_in_dollars * quantity
      space.cart_total_max_price_in_dollars = space.cart_unit_price_in_dollars * maxQuantity if maxQuantity

      space

    spaceTypesPrecedence = ['product_sampling', 'onsite_space', 'video_wall', 'social_media_post', 'promo']
    spaces = spaces.sort((a, b) =>
      x = parseInt(spaceTypesPrecedence.indexOf(a))
      y = parseInt(spaceTypesPrecedence.indexOf(b))
      if x > y then 1 else -1
    )

    spaces

  @eventSpacesForCampaign: (event, campaign) ->
    pricing_table = event.ctx.pricing_table

    spaces = for creative, descriptorList of campaign.creatives
      descriptor = descriptorList[0] or { line_item_pricing_model: 'custom', type: 'custom' }
      { line_item_pricing_model, type } = descriptor

      space = Object.values(event.spaces).find((s) -> s.type is type)
      continue unless space?
      pricing_model_descriptor = pricing_table[line_item_pricing_model] or { style: 'custom', price_in_cents: -1 }

      { style, price_in_cents } = pricing_model_descriptor
      price_in_cents = space.supplier_price_in_cents if 'marketplace' is style or not 0 is parseInt(price_in_cents)
      price_in_cents ||= space.supplier_price_in_cents

      quantity = space.min_quantity or 1
      quantity = event.reach if 'video_wall' is line_item_pricing_model

      maxQuantity = space.max_quantity

      space.cart_unit_price_in_dollars = price_in_cents / 100
      space.cart_total_price_in_dollars = space.cart_unit_price_in_dollars * quantity
      space.cart_total_max_price_in_dollars = space.cart_unit_price_in_dollars * maxQuantity if maxQuantity

      space

    spaceTypesPrecedence = ['product_sampling', 'onsite_space', 'video_wall', 'social_media_post', 'promo']
    spaces = spaces.sort((a, b) =>
      x = parseInt(spaceTypesPrecedence.indexOf(a))
      y = parseInt(spaceTypesPrecedence.indexOf(b))
      if x > y then 1 else -1
    )

    spaces

  @priceForVideoWall: (listing, pricingTable) ->
    pricingInCents = listing.ctx?.pricing_table?.video_wall?.price_in_cents
    pricingInCents ||= listing.pricing_table?.video_wall?.price_in_cents
    pricingInCents = pricingTable?.video_wall?.price_in_cents
    (listing.reach * pricingInCents) / 100

  @priceForProductSampling: (quantity, event, pricingTable, pricingModel='food_distribution') ->
    pricingInCents = event.ctx.pricing_table?[pricingModel]?.price_in_cents
    pricingInCents = pricingTable?[pricingModel]?.price_in_cents
    (quantity * pricingInCents) / 100

  @activationPlanForCampaign: (campaign, listing, segment, pricingTable, cart, target, options) ->
    useMinPurchase = options?.minimum_purchase_in_dollars || false
    target ||= campaign.target
    calendar = { events: CalendarService.normalizeEvents(listing.calendar_events), seasons: listing.calendar_seasons }

    { creatives } = campaign
    campaignHasSampling = Object.keys(creatives).includes('product_sampling')
    # campaignHasAssembly = creatives?.product_sampling[0]?.activation_snapshot?.supplier_provisions?.assembly?.required
    # campaignHasServeCold = creatives?.product_sampling[0]?.activation_snapshot?.supplier_provisions?.serve_cold?.required

    campaignStart = CalendarService.campaignStartDate target
    campaignEnd = CalendarService.campaignEndDate target
    availabilityWindows = CalendarService.eventAvailabilities calendar, campaignStart, campaignEnd
    capacity = CalendarService.maxReachForAvailabilityWindows availabilityWindows, listing, segment

    startDate = availabilityWindows[0].start
    endDate = availabilityWindows[availabilityWindows.length - 1].start

    itemTotalPriceInCents = 0
    lineItems = []

    availableDates = CalendarService.dateAvailability availabilityWindows
    totalQuantity = CalendarService.totalDailySamplingCapacity listing, segment, availableDates

    pricingModels = []
    for spaceKey, space of listing.spaces
      [spaceType, spaceSegment] = spaceKey.split ':'
      hasSegment = spaceSegment is segment
      hasCreative = !!creatives[spaceType]?[0]
      pricingModels.push creatives[spaceType][0].line_item_pricing_model if hasSegment and hasCreative

    for pricingModel in pricingModels
      quantity = capacity if campaignHasSampling
      quantity ||= -1

      totalPriceInCents = pricingTable[pricingModel].price_in_cents * quantity
      totalPriceInDollars = totalPriceInCents / 100

      itemTotalPriceInCents += totalPriceInCents

      lineItems.push {
        item: {
          pricing_model: pricingModel,
          quantity,
          total_price_in_dollars: totalPriceInDollars,
        },
        addons: {
          # 'serve_cold':
          #     pricingModel: '',
          #     quantity: -1,
          #     totalPriceInDollars: -1,
        }
      }

    itemTotalPriceInDollars = itemTotalPriceInCents / 100

    {
      segment,
      reach: -1,
      capacity,
      quantity: totalQuantity,
      start_date: startDate,
      end_date: endDate,
      total_price_in_dollars: itemTotalPriceInDollars,
      available_dates: availableDates,
      line_items: lineItems,
    }

  @activationPlanForCart: (campaign, listing, segment, pricingTable, cart, target, options) ->
    target ||= campaign.target
    calendar = { events: CalendarService.normalizeEvents(listing.calendar_events), seasons: listing.calendar_seasons }

    today = dayjs().format(CalendarService.DATE_FORMAT)
    end = dayjs().add(1, 'year').format(CalendarService.DATE_FORMAT)
    availabilityWindows = CalendarService.eventAvailabilities calendar, today, end
    capacity = CalendarService.maxReachForAvailabilityWindows availabilityWindows, listing, segment

    startDate = availabilityWindows[0].start
    endDate = availabilityWindows[availabilityWindows.length - 1].start

    itemTotalPriceInCents = 0
    lineItems = []

    listingLineItems = (cart?.line_items || []).filter((lineItem) ->
      lineItemSegment = lineItem.space_name.split(':')[1]
      sameId = lineItem.ctx.audience_listing.id is listing.id
      sameSegment = lineItemSegment is segment
      sameId and sameSegment
    )

    availableDates = listingLineItems[0].available_dates if listingLineItems.length
    totalQuantity = CalendarService.totalDailySamplingCapacity listing, segment, availableDates

    for listingLineItem in listingLineItems
      pricingModel = listingLineItem.pricing_model
      quantity = listingLineItem.quantity
      totalPriceInDollars = listingLineItem.total_price_in_dollars

      totalPriceInCents = listingLineItem.total_price_in_dollars * 100
      itemTotalPriceInCents += totalPriceInCents

      lineItems.push {
        item: {
          pricing_model: pricingModel,
          quantity,
          total_price_in_dollars: totalPriceInDollars,
        },
        addons: {
          # 'serve_cold':
          #     pricingModel: '',
          #     quantity: -1,
          #     totalPriceInDollars: -1,
        }
      }

    itemTotalPriceInDollars = itemTotalPriceInCents / 100

    {
      segment,
      reach: -1,
      capacity,
      quantity: totalQuantity,
      start_date: startDate,
      end_date: endDate,
      total_price_in_dollars: itemTotalPriceInDollars,
      available_dates: availableDates,
      line_items: lineItems,
    }

  @activationPlanForListing: (campaign, listing, segment, pricingTable, cart, target, options) ->
    listingLineItems = (cart?.line_items || []).filter((lineItem) ->
      lineItemSegment = lineItem.space_name.split(':')[1]
      sameId = lineItem.ctx.audience_listing.id is listing.id
      sameSegment = lineItemSegment is segment
      sameId and sameSegment
    )

    if listingLineItems.length
      plan = @activationPlanForCart campaign, listing, segment, pricingTable, cart, target, options
    else
      plan = @activationPlanForCampaign campaign, listing, segment, pricingTable, cart, target, options

    plan

export default PricingModel